import { 
    SAVE_ANSWER as SOCKET_SAVE_ANSWER, 
    DELETE_ANSWER as SOCKET_DELETE_ANSWER 
} from '../../events/DashboardToServer'

export const SAVE_ANSWER = 'SAVE_ANSWER'
export const SAVED_ANSWER = 'SAVED_ANSWER'
export const RECEIVE_ANSWERS = 'RECEIVE_ANSWERS'
export const DELETE_ANSWER = 'DELETE_ANSWER'
export const DELETED_ANSWER = 'DELETED_ANSWER'
export const EDIT_ANSWER = 'EDIT_ANSWER'

export const saveAnswer = (socket, answer) => {
    const id = answer.id || 'a-' + Math.random()
    answer.id = id
    socket.emit(SOCKET_SAVE_ANSWER, { answer })
    return { type: SAVE_ANSWER, answer }
}

export const savedAnswer = (answer, prevId) => {
    return { type: SAVED_ANSWER, answer, prevId }
}

export const receiveAnswers = (answers) => {
    return {type: RECEIVE_ANSWERS, answers }
}

export const deleteAnswer = (socket, answer) => {
    socket.emit(SOCKET_DELETE_ANSWER, { answer })
    return { type: DELETE_ANSWER, answer }
}

export const deletedAnswer = (answer) => {
    return { type: DELETED_ANSWER, answer }
}

export const editAnswer = (answer) => {
    return { type: EDIT_ANSWER, answer }
}


// WEBPACK FOOTER //
// ./src/reducers/answers/actions.js